module.exports = __webpack_public_path__ + "img/home-card-bg.08611f22.png";